import { useAppSelector } from 'hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import { productDescriptionsRequested } from 'state/product-description/action';
import { selectProductDescriptionStatus } from 'state/product-description/selectors';
import { productsReferentialRequested } from 'state/productsReferential/productsReferential.action';
import { selectProductsReferentialStatus } from 'state/selectors';

export function useProductFormGuard() {
  const descriptionStatus = useAppSelector(selectProductDescriptionStatus);
  const referentialStatus = useAppSelector(selectProductsReferentialStatus);

  const isProductsDescriptionLoading = descriptionStatus.isLoading;
  const isProductsReferentialLoading = referentialStatus.isLoading || referentialStatus.isEmpty;
  const isProductsDescriptionError = descriptionStatus.isError || descriptionStatus.isTimeout;
  const isProductsReferentialError = referentialStatus.isError;

  const dispatch = useDispatch();

  const onReloadProductDescriptions = () => dispatch(productDescriptionsRequested());
  const onReloadProductReferential = () => dispatch(productsReferentialRequested());

  return {
    isProductsDescriptionLoading,
    isProductsReferentialLoading,
    isProductsDescriptionError,
    isProductsReferentialError,
    onReloadProductDescriptions,
    onReloadProductReferential,
  };
}
